import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Badge } from '@/components/ui/badge'

type Props = {
  description?: string
  unit?: string
  required: boolean
}

export function InlineFieldTooltip({ description, unit, required }: Props) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Aide sur ce champ"
          className="w-5 h-5 rounded-full text-xs font-bold flex items-center justify-center text-white flex-shrink-0"
          style={{ backgroundColor: 'var(--supplier-primary)' }}
        >
          ?
        </button>
      </PopoverTrigger>
      <PopoverContent className="max-w-[280px] space-y-2">
        {description && <p className="text-sm">{description}</p>}
        {unit && <p className="text-xs text-muted-foreground">Unité : {unit}</p>}
        {required ? (
          <Badge variant="destructive">Obligatoire</Badge>
        ) : (
          <Badge variant="secondary">Optionnel</Badge>
        )}
      </PopoverContent>
    </Popover>
  )
}
